import React from "react";
import Section from "./section";
import SectionTitle from "./section-title";
import Reveal from "./reveal";
import { testimonials } from "../content/site";

export default function Testimonials() {
  return (
    <Section>
      <SectionTitle
        eyebrow="Client Voices"
        title={<>What partners say <span className="gradient">about working with us.</span></>}
        text="Clear communication, honest reporting and a team that cares about outcomes."
      />
      <div className="grid grid-3">
        {testimonials.map((t, i) => (
          <Reveal className="testimonial" key={t.org} delay={i * 0.08}>
            <div className="stars" aria-label="5 out of 5 stars">★★★★★</div>
            <blockquote>{t.quote}</blockquote>
            <div className="testimonial-by">
              <div className="avatar">{t.initials}</div>
              <div><b>{t.by}</b><span>{t.org}</span></div>
            </div>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
